import { registerSecureBinding } from "DistributedTasksCommon/TFS.Knockout.Secure";

registerSecureBinding();